import { Component } from '@angular/core';

@Component({
  selector: 'app-inner-header',
  templateUrl: './inner-header.component.html',
  styleUrls: ['./inner-header.component.css']
})
export class InnerHeaderComponent {

  isCollapsed = true;
  theme: any;
  themeList: any
  toggleClass(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      document.getElementsByTagName("body")[0].classList.add("sbMenu");
     
    } else {
      document.getElementsByTagName("body")[0].classList.add("sbMenu");
       document.getElementsByClassName("smClose")[1].classList.add("active");
    }
}

toggleClass1(event: any, className: string) {
  const hasClass = event.target.classList.contains(className);
  if (hasClass) {
    document.getElementsByTagName("body")[0].classList.remove("sbMenu");
   
  } else {
    document.getElementsByTagName("body")[0].classList.remove("sbMenu");
     document.getElementsByClassName("smClose")[1].classList.remove("active");
  }
}

toggleClass3(event: any, className: string) {
  const hasClass = event.target.classList.contains(className);
  if (hasClass) {
    document.getElementsByTagName("body")[0].classList.remove("darktheme");
  } else {
    localStorage.removeItem('dark-Theme');
    document.getElementsByTagName("body")[0].classList.remove("darktheme");
    document.getElementsByClassName("smClose")[1].classList.add("active");
  }
}

toggleClass2(event: any, className: string) {
  const hasClass = event.target.classList.contains(className);
  if (hasClass) {
    document.getElementsByTagName("body")[0].classList.add("darktheme");
  } else {
    this.theme = 'darktheme'; 
    localStorage.setItem('dark-Theme', this.theme);
    document.getElementsByTagName("body")[0].classList.add(this.theme);
    document.getElementsByClassName("smClose")[1].classList?.add("active");
  }
}

}
